import { OrganizationManager, PartnerOrganization } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { PartnerOrganizationManagerEntityConfig } from "./config";
import { PartnerOrganizationManagerFilters } from "./filters";
import { PartnerOrganizationManagerMethods } from "./methods";

@HyperEntity("partner-organization-manager", PartnerOrganizationManagerEntityConfig)
export class PartnerOrganizationManager extends extender(
  PartnerOrganizationManagerFilters,
  PartnerOrganizationManagerMethods,
) {
  @Fields.string({ dbName: "partner_organization_id" })
  partnerOrganizationId = "";

  @Fields.string({ dbName: "manager_id" })
  managerId = "";

  @Relations.toOne<PartnerOrganizationManager, PartnerOrganization>(
    () => PartnerOrganization,
    "partnerOrganizationId",
  )
  partnerOrganization?: PartnerOrganization;

  @Relations.toOne<PartnerOrganizationManager, OrganizationManager>(
    () => OrganizationManager,
    "managerId",
  )
  manager?: OrganizationManager;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
